<section class="section white-100" *ngIf="borderLess">
  <div
    [ngClass]="
      isMarginBottom ? 'section-container' : 'section-container-inside'
    "
  >
    <div class="be-truly">
      <div class="section-be-truly">
        <div class="be-truly-heading">
          {{ borderLess?.title }}
          <div class="play-store">
            <a
              href="{{
                borderLess?.component1[0]?.fields.components[0].fields.link
              }}"
              target="_blank"
              (click)="onAppStoreClick(borderLess?.component1[0]?.fields.components[0].fields.link)"
            >
              <img
                loading="lazy"
                class="play-store-btn"
                src="{{
                  borderLess.component1[0]?.fields.components[0].fields
                    .iconImage.fields.file.url
                }}"
                alt="Button 1"
              />
            </a>
            <a
              href="{{
                borderLess?.component1[0]?.fields.components[1].fields.link
              }}"
              target="_blank"
              (click)="onPlayStoreClick(borderLess?.component1[0]?.fields.components[1].fields.link)"
            >
              <img
                loading="lazy"
                class="play-store-btn google-btn"
                src="{{
                  borderLess.component1[0]?.fields.components[1].fields
                    .iconImage.fields.file.url
                }}"
                alt="Button 2"
              />
            </a>
          </div>
        </div>
        <img
          loading="lazy"
          [src]="borderLess.image[0].fields.file.url"
          alt=""
        />
      </div>
    </div>
  </div>
</section>
